export const InviteMobileAPI = async (phone, assignerName) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}send-invite-mobile`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                phone: phone,
                assignerName: assignerName,
                type: "whatsapp"
            })
        });

        if (!response.ok) {
            console.error(`Failed to send invite mobile, status: ${response.status}`);
            return null;
        }

        return await response.json();

    } catch (error) {
        console.error("Error sending invite mobile:", error);
        return null;
    }
};
